'use client';
var classes = {"legend":"m-847eaf","legendItem":"m-17da7e62","legendItemName":"m-8ff56c0d"};

export { classes as default };
//# sourceMappingURL=ChartLegend.module.css.mjs.map
